var _rect, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSidebarimg4(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 16,
    fill: "url(#paint0_linear_3_5347)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.5614 19.266C27.6046 19.1876 27.668 19.1222 27.7451 19.0767C27.8221 19.0312 27.91 19.0071 27.9994 19.0071C28.0889 19.0071 28.1768 19.0312 28.2538 19.0767C28.3309 19.1222 28.3943 19.1876 28.4374 19.266L31.3894 24.87C31.4598 24.9997 31.5581 25.1123 31.6772 25.1996C31.7962 25.2869 31.9331 25.3467 32.078 25.3748C32.223 25.403 32.3723 25.3986 32.5154 25.3622C32.6584 25.3257 32.7916 25.258 32.9054 25.164L37.1824 21.5C37.2646 21.4332 37.3657 21.3942 37.4714 21.3886C37.5771 21.383 37.6818 21.411 37.7705 21.4687C37.8593 21.5264 37.9274 21.6108 37.9651 21.7097C38.0028 21.8086 38.0082 21.9169 37.9804 22.019L35.1464 32.265C35.0886 32.4747 34.964 32.6597 34.7915 32.7922C34.6189 32.9247 34.4079 32.9973 34.1904 32.999H21.8094C21.5918 32.9975 21.3806 32.925 21.2078 32.7925C21.0351 32.66 20.9103 32.4748 20.8524 32.265L18.0194 22.02C17.9917 21.9179 17.9971 21.8096 18.0348 21.7107C18.0725 21.6118 18.1406 21.5274 18.2293 21.4697C18.3181 21.412 18.4228 21.384 18.5285 21.3896C18.6342 21.3952 18.7353 21.4342 18.8174 21.501L23.0934 25.165C23.2072 25.259 23.3405 25.3267 23.4835 25.3632C23.6266 25.3996 23.7759 25.404 23.9208 25.3758C24.0658 25.3477 24.2027 25.2879 24.3217 25.2006C24.4408 25.1133 24.5391 25.0007 24.6094 24.871L27.5614 19.266Z",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21 37H35",
    stroke: "white",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_5347",
    x1: 28,
    y1: 0,
    x2: 28,
    y2: 56,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSidebarimg4);
export default __webpack_public_path__ + "static/media/sidebar img 4.d3b0356a12776207458899bc1be17b1b.svg";
export { ForwardRef as ReactComponent };